module.exports = "/images/btn.png?76dd717d3c759bb689dafc374f8fb44f";